module.exports = __webpack_public_path__ + "static/media/Sports.674777d4.svg";